import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useCompanyInsightChartData = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);
    const [companyInsightChartData, setCompanyInsightChartData] = useState<any>(null);

    const onGetCompanyInsightError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(
            err?.response?.data?.message ?? 'Something went wrong while retrieving company insight data.',
        );
    };

    const onGetCompanyInsightChartDataSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<CompanyInsightChartDataInterface>) => {
        setCompanyInsightChartData(data ?? null);

    };

    const getCompanyInsightChartData = (id: any) => {
        const url: HttpConfig = {
            url: `ba/v1/company/${id}/insights`,
            method: 'get',
        };

        request(url, onGetCompanyInsightChartDataSuccess, setLoading, onGetCompanyInsightError);
    };

    return { getCompanyInsightChartData, loading, companyInsightChartData };
};

export default useCompanyInsightChartData;

export interface CompanyInsightChartDataInterface {
    id: string;
    name: string;
    accountStatus: string;
    userRoleName: string;
    categoryOfFleets: string[];
    lookupCount: number;
    onPlatformSince: string;
    profilePicture: string;
    workerTypeDistribution: WorkerTypeDistribution[];
    exitReasons: ExitReason[];
    conflictIssues: ConflictIssue[];
    reports: Report[];
    conflicts: Conflict[];
    performanceTimeline: PerformanceTimeline[];
}

export interface WorkerTypeDistribution {
    name: string;
    value: number;
    color: string;
    textColor: string;
}

export interface ExitReason {
    name: string;
    value: number;
    color: string;
    textColor: string;
}

export interface ConflictIssue {
    name: string;
    value: number;
    color: string;
    textColor: string;
}

export interface Report {
    name: string;
    value: number;
    color: string;
    textColor: string;
}

export interface Conflict {
    name: string;
    value: number;
    color: string;
    textColor: string;
}

export interface PerformanceTimeline {
    year: number;
    month: number;
    monthName: string;
    averageTierScore: number;
}
